import React, { useState, useEffect } from "react";
import banner_img from "../../../images/banner-picture.png";
import login_logo from "../../../images/loginlogo.png";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { InputLabel, Input, InputAdornment, IconButton } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import "./Signuptwo.css";
import { userSignupApi } from "../../../Services/Signup/SignupApi/SignupApi";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify"; // Import Toast components
import "react-toastify/dist/ReactToastify.css"; // Import styles for toast notifications
import { Country, State, City } from "country-state-city";
import { fetchCommunityData } from "../../../Services/Community/CommunityAPI/communityApi";
import { fetchUserType } from "../../../Services/Signup/SignupApi/SignupApi";
import HorizontalLinearStepper from "../../Stepper/Stepper";
import { userForgotPasswordApi } from "../../../Services/Login/LoginApi/loginApi";

function SignuptwoComp() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const location = useLocation();
  const formData = location.state || {};
  const [statesUS, setStatesUS] = useState([]);
  const [cities, setCities] = useState([]);
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const [showNewPassword, setShowNewPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const { data } = useSelector((state) => state.community);
  const usertype = useSelector((state) => state.fetchUserType.data);

  const [formValues, setFormValues] = useState({
    address: "",
    building: "",
    state: "",
    city: "",
    zipcode: "",
    newPassword: "",
    confirmPassword: "",
    termsAccepted: false,
  });

  useEffect(() => {
    // Check localStorage
    const stepOneComplete = localStorage.getItem("signupStepOneComplete");

    if (!stepOneComplete) {
      navigate("/signupone"); // Redirect to first step
    }
  }, [navigate]);


  // Fetch all states when the component mounts
  useEffect(() => {
    const fetchedStates = State.getStatesOfCountry("US"); // 'US' is the country code for United States
    setStatesUS(fetchedStates);
  }, []);

  useEffect(() => {
    dispatch(fetchUserType());
  }, [dispatch]);

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    let updatedValue = type === "checkbox" ? checked : value;

    if (name === "zipcode") {
      updatedValue = value.replace(/\D/g, "").slice(0, 5);
    }

    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: updatedValue,
    }));

    if (name === "state") {
      const fetchedCities = City.getCitiesOfState("US", value); // Fetch cities for selected state
      setCities(fetchedCities);
      setFormValues((prevValues) => ({ ...prevValues, city: "" })); // Reset city value
    }
  };

  const validateForm = () => {
    const validationErrors = {};

    if (!formValues.address.trim()) {
      validationErrors.address = "Address is required.";
    }
    // if (!formValues.building.trim()) {
    //   validationErrors.building = "Building/Suite/Unit is required.";
    // }
    if (!formValues.state) {
      validationErrors.state = "State is required.";
    }
    if (!formValues.city) {
      validationErrors.city = "City is required.";
    }

    // Updated Zipcode validation
    if (!formValues.zipcode.trim()) {
      validationErrors.zipcode = "Zipcode is required.";
    } else if (!/^\d{5}(-\d{4})?$/.test(formValues.zipcode)) {
      validationErrors.zipcode =
        "A valid 5-digit Zipcode or ZIP+4 format (12345 or 12345-6789) is required.";
    }

    if (!formValues.newPassword.trim()) {
      validationErrors.newPassword = "Password is required.";
    } else if (
      !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/.test(
        formValues.newPassword
      )
    ) {
      validationErrors.newPassword =
        "Password must contain at least 8 characters, including uppercase, lowercase, numerals, and symbols.";
    }
    if (formValues.newPassword !== formValues.confirmPassword) {
      validationErrors.confirmPassword = "Passwords do not match.";
    }
    if (!formValues.termsAccepted) {
      validationErrors.termsAccepted =
        "You must accept the terms and conditions.";
    }

    setErrors(validationErrors);
    return Object.keys(validationErrors).length === 0;
  };

  // const mappedData = {
  //   role_id: formData?.userType,
  //   first_name: formData?.firstName || "",
  //   last_name: formData?.lastName || "",
  //   email: formData?.email || "",
  //   password: formValues.newPassword || "",
  //   phone_number: formData?.phoneNumber || "",
  //   address: formValues.address || "",
  //   bldg_suite_unit: formValues.building || "",
  //   zipcode: formValues.zipcode || "",
  //   city: formValues.city || "",
  //   state: formValues.state || "",
  //   image: formData.image,
  // };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!validateForm()) {
      Object.values(errors).forEach((error) => {
        toast.error(error);
      });
      return;
    }
    try {
      const formDataToSend = new FormData();

      formDataToSend.append("role_id", formData?.userType);
      formDataToSend.append("first_name", formData?.firstName || "");
      formDataToSend.append("last_name", formData?.lastName || "");
      formDataToSend.append("email", formData?.email || "");
      formDataToSend.append("password", formValues.newPassword || "");
      formDataToSend.append("phone_number", formData?.phoneNumber || "");
      formDataToSend.append("address", formValues.address || "");
      formDataToSend.append("bldg_suite_unit", formValues.building || "");
      formDataToSend.append("zipcode", formValues.zipcode || "");
      formDataToSend.append("city", formValues.city || "");
      formDataToSend.append("state", formValues.state || "");

      if (formData?.image instanceof File) {
        formDataToSend.append("image", formData.image);
      }
      const response = await dispatch(userSignupApi(formDataToSend)).unwrap();

      if (response?.status === 201) {
        toast.success("Registration successfull !");
        setTimeout(() => {
          // navigate("/login");

          localStorage.removeItem("signupStepOneComplete");
          
        }, 3000);
            const result = await dispatch(
          userForgotPasswordApi({
            email: formData?.email,
          })
        );
    
        if (userForgotPasswordApi.fulfilled.match(result)) {
          navigate(`/email-verification?email=${encodeURIComponent(formData?.email)}`); 
          localStorage.removeItem("signupFormData");
        }  else {
          // toast.error("Please Enter the correct Email!");
          console.error("Failed to submit email:", result.payload);
        }
      }
    } catch (err) {
      toast.error("Registration failed: Invalid Details or already Register !");
    }
  };

  const handleLogingroute = () => {
    navigate("/login");
  };

  const matchingRoleNames =
    usertype?.data
      ?.filter((data) => data?.role_name === "Homeowner")
      ?.map((data) => data?.id) || [];

  return (
    <>
      <section className="login-page-one signuptwo-blk">
        <div className="container-fluid p-0 m-0">
          <div className="row m-0 loginpage">
            <div className="col-md-6 signuptwo">
              <div className="login-right-block logo-left-block mb-4">
                <div className="login-logoimg text-center">
                  <img
                    src={login_logo}
                    alt="login-logo"
                    className="login_logo_img"
                  ></img>
                </div>
              </div>
              <div className="banner-contents">
                <div className="banner-image email-verify-blk">
                  {/* <img src={banner_img} alt="banner-image"></img> */}
                  <div className="text-overlay">
                  <h5>Let's Setup Your Operating Agreement</h5>
                  <p>
                    Elevate your business insights with precision. Log in to
                    discover and refine your Ideal Customer Profiles
                    effortlessly.
                  </p>
                </div>
                </div>
               
              </div>
            </div>
            <div className="col-md-6 signuptwo-col login-cols-block">
              <div className="login-right-block desktop-view">
                <div className="login-logoimg text-center">
                  <Link to="/">
                    <img
                      src={login_logo}
                      alt="login-logo"
                      className="login_logo_img"
                    />
                  </Link>
                </div>
                <div className="stepper  mb-4 d-flex justify-content-between align-items-center">
                {/* <div className="stepper-innner">
                  <Link
                    to="/signupone"
                    className=" d-flex flex-column align-items-center gap-1"
                  >
                    <div className="stepper-dot-fade active"></div>
                    <div className="step-no-fade active">Step 1</div>
                  </Link>
                </div>
                <div className="stepper-line active"></div>
                <div className="stepper-innner">
                  <a className=" d-flex flex-column align-items-center gap-1">
                    <div className="stepper-dot-fade active"></div>
                    <div className="step-no-fade active">Step 2</div>
                  </a>
                </div> */}
                  <HorizontalLinearStepper activeStepProp={1} />
              </div>
              </div>
              <div className="stepper stepper-responsive mb-3 d-flex justify-content-between align-items-center">
                                            {/* <div className="stepper-innner">
                                              <Link
                                                to="/signupone"
                                                className=" d-flex flex-column align-items-center gap-1"
                                              >
                                                <div className="stepper-dot-fade active"></div>
                                                <div className="step-no-fade active">Step 1</div>
                                              </Link>
                                            </div>
                                            <div className="stepper-line active"></div>
                                            <div className="stepper-innner">
                                              <a className=" d-flex flex-column align-items-center gap-1">
                                                <div className="stepper-dot-fade active"></div>
                                                <div className="step-no-fade active">Step 2</div>
                                              </a>
                                            </div> */}
                                              <HorizontalLinearStepper activeStepProp={1}/>
                                          </div>
              <div className="login-page-area">
                <div className="login-information log-in">
                  <div className="form-login text-left">
                    <div className="mb-4 mt-3">
                      <InputLabel htmlFor="address">
                        Address<span>*</span>
                      </InputLabel>
                      <Input
                        className="address-input"
                        id="address"
                        type="text"
                        name="address"
                        placeholder="Enter Address"
                        value={formValues.address}
                        onChange={handleChange}
                      />
                      {errors.address && (
                        <p className="error-text">{errors.address}</p>
                      )}
                    </div>

                    <div className="mb-4">
                      <InputLabel htmlFor="building">
                        Building, Suite or Unit
                      </InputLabel>
                      <Input
                        className="building-input"
                        id="building"
                        type="text"
                        name="building"
                        placeholder="Enter Building, Suite or Unit"
                        value={formValues.building}
                        onChange={handleChange}
                      />
                      {errors.building && (
                        <p className="error-text">{errors.building}</p>
                      )}
                    </div>
                    <div className="mb-4">
                      <InputLabel htmlFor="user-type-select">
                        State<span>*</span>
                      </InputLabel>
                      <select
                        className="user-type-dropdown"
                        id="user-type-selectt"
                        defaultValue=""
                        name="state"
                        value={formValues.state}
                        onChange={handleChange}
                      >
                        <option value="" disabled>
                          Select State
                        </option>
                        {statesUS.map((state) => (
                          <option key={state.isoCode} value={state.isoCode}>
                            {state.name}
                          </option>
                        ))}
                      </select>
                      {errors.state && (
                        <p className="error-text">{errors.state}</p>
                      )}
                    </div>
                    <div className="mb-4">
                      <div className="city-zipcode-container">
                        <div className="city-div">
                          <InputLabel htmlFor="city" className="mb-0">
                            City<span>*</span>
                          </InputLabel>
                          <select
                            className="user-type-dropdown"
                            id="city"
                            name="city"
                            value={formValues.city}
                            onChange={handleChange}
                          >
                            <option value="" disabled>
                              Select City
                            </option>
                            {cities.map((city) => (
                              <option key={city.name} value={city.name}>
                                {city.name}
                              </option>
                            ))}
                          </select>
                          {errors.city && (
                            <p className="error-text">{errors.city}</p>
                          )}
                        </div>
                        <div className="zipcode-div">
                          <InputLabel htmlFor="zipcode" className="mb-0">
                            Zip Code<span>*</span>
                          </InputLabel>
                          <Input
                            className="zipcode-input"
                            id="zipcode"
                            type="text"
                            name="zipcode"
                            placeholder="Enter Zip Code"
                            value={formValues.zipcode}
                            onChange={handleChange}
                          />
                          {errors.zipcode && (
                            <p className="error-text">{errors.zipcode}</p>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="mb-4">
                      <InputLabel htmlFor="new-password">
                        Password <span>*</span>
                      </InputLabel>
                      <Input
                        className="password-input-box"
                        id="new-password"
                        placeholder="New Password"
                        name="newPassword"
                        type={showNewPassword ? "text" : "password"}
                        value={formValues.newPassword}
                        onChange={handleChange}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label={
                                showNewPassword
                                  ? "hide the password"
                                  : "display the password"
                              }
                              onClick={() =>
                                setShowNewPassword((prev) => !prev)
                              }
                              onMouseDown={(event) => event.preventDefault()}
                            >
                              {showNewPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                      {errors.newPassword && (
                        <p className="error-text">{errors.newPassword}</p>
                      )}
                      <div className="pw-text-bottom">
                        Password should be the combination of{" "}
                        <span>
                          Uppercase & Lowercase Letters, Numerals and Symbols
                        </span>
                        .
                      </div>
                    </div>

                    <div className="mb-4">
                      <InputLabel htmlFor="confirm-password">
                        Confirm Password <span>*</span>
                      </InputLabel>
                      <Input
                        className="password-input-box"
                        id="confirm-password"
                        placeholder="Confirm Password"
                        name="confirmPassword"
                        type={showConfirmPassword ? "text" : "password"}
                        value={formValues.confirmPassword}
                        onChange={handleChange}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label={
                                showConfirmPassword
                                  ? "hide the password"
                                  : "display the password"
                              }
                              onClick={() =>
                                setShowConfirmPassword((prev) => !prev)
                              }
                              onMouseDown={(event) => event.preventDefault()}
                            >
                              {showConfirmPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                      {errors.confirmPassword && (
                        <p className="error-text">{errors.confirmPassword}</p>
                      )}
                    </div>

                    <div className="mb-4 checkbox d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-start">
                        <div>
                          <Checkbox
                            {...label}
                            className="check-box pt-0"
                            checked={formValues.termsAccepted}
                            onChange={handleChange}
                            name="termsAccepted"
                          />
                        </div>
                        <span className="password-text">
                          By clicking Create an account, I agree that I have
                          read and accepted the <span>Terms of Use</span> and{" "}
                          <span>Privacy Policy</span>.
                        </span>
                      </div>
                    </div>
                    <div className="btn-orange">
                      <Button onClick={handleSubmit}>Create an Account</Button>
                    </div>
                    <div className="lower-signup-text text-center">
                      <p>
                        Already have an account?{" "}
                        <a href="" onClick={handleLogingroute}>
                          Log In
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ToastContainer for toast notifications */}
      <ToastContainer />
    </>
  );
}

export default SignuptwoComp;
